import { render } from "./code.vue?vue&type=template&id=0a3c9ef7&scoped=true"
import script from "./code.vue?vue&type=script&lang=js"
export * from "./code.vue?vue&type=script&lang=js"

import "./code.vue?vue&type=style&index=0&id=0a3c9ef7&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3c9ef7"]])

export default __exports__